import { render } from "./SearchContainer.vue?vue&type=template&id=4b588293&lang=pug"
import script from "./SearchContainer.vue?vue&type=script&lang=js"
export * from "./SearchContainer.vue?vue&type=script&lang=js"

import "./SearchContainer.vue?vue&type=style&index=0&id=4b588293&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__